import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import axios from "axios";
import { colors } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";
import dayjs from 'dayjs';

const PublicationContext = createContext();

export const PublicationProvider = ({ children }) => {
  const [rows, setRows] = useState([]);
  // const [row, setRow] = useState([]);
  const [editId, setEditId] = useState();
  const [offers, setOffers] = useState([]);
  const [news, setNews] = useState([]);
  const [error, setError] = useState("");

  const lastLogin = async (editId) => {
    let timestamp = localStorage.getItem("timestamp"); // may be null
    const userId = localStorage.getItem("ueserId");

    if (!timestamp) {
      console.warn("No timestamp found in localStorage, using current time");
      timestamp = new Date().toISOString(); // default current time
    }

    // Ensure timezone info exists
    const dateObj = new Date(timestamp.endsWith("Z") ? timestamp : timestamp + "Z");

    if (isNaN(dateObj.getTime())) {
      console.error("Invalid timestamp format:", timestamp);
      return;
    }

    const formattedDate = dateObj.toISOString(); // final ISO UTC format

    try {
      const sessionToken = localStorage.getItem("sessionToken");

      const response = await axios.put(
        `https://api.exampladmedia.com/auth/edit/${userId}`,
        {
          lastLogin: formattedDate,
        },
        {
          headers: {
            Authorization: sessionToken,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("got this userdata");
      }
    } catch (error) {
      console.error("Error updating last login:", error);
    }
  };

  const fetchUserIds = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.get("https://api.exampladmedia.com/auth/getAllUsers", {
        headers: {
          Authorization: sessionToken,
        },
      });

      // Get an array of userIds (excluding SUPER_ADMIN if needed)
      const userIds = response.data
        .filter((user) => user.userRole !== "SUPER_ADMIN") // Optional filter
        .map((user) => user.userId);

      console.log("User IDs:", userIds);
      return userIds;
    } catch (error) {
      console.error("Error fetching user IDs:", error);
      return [];
    }
  };

  const fetchPublications = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await fetch("https://api.exampladmedia.com/api/publications/getAllPublication", {
        method: "GET",
        headers: {
          Authorization: sessionToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // console.log("API Response table:", data);
      if (response.ok) {
        try {
          console.log("called");
          // lastLogin(data[0].userId);
          lastLogin();
          // fetchUserIds()
        } catch (e) {
          console.error("got error ", e);
        }
      }

      const converted = data.map((item) => {
        setEditId(item.userId);
        const trimmedTimestamp = item.timestamp.substring(0, 23); // to milliseconds
        const date = new Date(trimmedTimestamp);
        const timestamp = localStorage.setItem("timestamp", trimmedTimestamp);
      });

      if (response.ok) {
        const lastLogin = localStorage.setItem("timestamp", response.timestamp);
      }

      const formattedRows = Array.isArray(data)
        ? data.map((item) => ({
          userId: item.userId,

          publication: (
            <a
              href={item.sample ? item.sample : "#"}
              target={item.sample ? "_blank" : "_self"}
              rel="noopener noreferrer"
              style={{
                color: item.sample ? "blue" : "gray",
                pointerEvents: item.sample ? "auto" : "none",
                textDecoration: "none",
              }}
            >
              {item.publication}
            </a>
          ),
          publicationText: item.publication,
          // publication: item.publication || "N/A",
          marginPrice: parseInt(item.marginPrice, 10) || 0,
          orgPrice: item.orgPrice || "",
          gstPrice: item.gstPrice,
          createdDate: item.createdDate ? dayjs(item.createdDate).format("DD-MMM-YYYY") : "-",
          lastmodifiedBy: item.lastmodifiedBy,
          // lastmodifiedDate: item.lastUpdateDate ? dayjs(item.lastUpdateDate).format("DD-MMM-YYYY HH:MM:ss") : "-",
          lastmodifiedDate: item.lastUpdateDate ? item.lastUpdateDate : "-",
          usdPrice: item.usdPrice || 0,
          modeType: item.modeType || null,
          wordsAllowed: parseInt(item.wordsAllowed, 10) || 0,
          backlinksAllowed: item.backlinksAllowed !== null ? item.backlinksAllowed : "N/A",
          tat: item.tat || "N/A",
          sponsored: item.sponsored ? "Yes" : "No",
          indexed: item.indexed ? "Yes" : "No",
          doFollow: item.doFollow ? "Yes" : "No",
          doFollow2: item.doFollow2
            ? item.doFollow2.charAt(0).toUpperCase() + item.doFollow2.slice(1)
            : "NO",
          index2: item.index2 ? item.index2.charAt(0).toUpperCase() + item.index2.slice(1) : "NO",
          packageName: item.packageName || "",
          platformName: item.platformName || "",
          collab: item.collab ? item.collab.charAt(0).toUpperCase() + item.collab.slice(1) : "NO",
          genres: Array.isArray(item.genres) ? item.genres.join(", ") : "",
          disclaimer: Array.isArray(item.disclaimer) ? item.disclaimer.join(", ") : "",

          //           sample: item.sample ? (
          //             <a href={item.sample} target="_blank" rel="noopener noreferrer">
          //               Go to the link
          //             </a>
          //           ) : (
          //             <span className="custom-tooltip" data-tooltip="Contact us for sample
          // ">
          //               N/A
          //             </span>
          //           ),

          daChecker: item.daChecker ? (
            <a href={item.daChecker} target="_blank" rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                color: "#1A73E8",
                transition: "0.2s ease",
                "&:hover": {
                  transform: "scale(1.2)",
                },
              }}>
              {/* <SearchIcon /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ cursor: "pointer" }}
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check DA" arrow placement="top">
              <ClearIcon />
            </Tooltip>
          ),
          sample: item.sample ? (
            <a href={item.sample} target="_blank" rel="noopener noreferrer">
              Sample
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check" arrow placement="top">
              <span>N/A</span>
            </Tooltip>
          ),

          trafficChecker: item.trafficChecker ? (
            <a href={item.trafficChecker} target="_blank" rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                color: "#1A73E8",
                transition: "0.2s ease",
                "&:hover": {
                  transform: "scale(1.2)",
                },
              }}>
              {/* <SearchIcon /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ cursor: "pointer" }}
              >
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                <polyline points="17 6 23 6 23 12"></polyline>
              </svg>
            </a>
          ) : (
            <Tooltip title="Sample unavailable to check Traffic" arrow placement="top">
              <ClearIcon />
            </Tooltip>
          ),
          publicationNames: Array.isArray(item.publicationNames) ? item.publicationNames : [],
          sampleUrls: Array.isArray(item.sampleUrls) ? item.sampleUrls : [],
        }))
        : [];

      setRows(formattedRows);
    } catch (error) {
      console.error("Error fetching publications:", error.message);
    }
  };

  const fetchOffers = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
      if (!sessionToken) {
        console.error("Session token not found.");
        return;
      }

      const response = await axios.get(
        "https://api.exampladmedia.com/api/offerAndNews/getAllOfferAndNews",
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );

      const offers = response.data.data.filter((item) => item.type === "OFFERS");
      const news = response.data.data.filter((item) => item.type === "NEWS");

      setOffers(offers);
      setNews(news);
      // setLoading(false);
    } catch (err) {
      setError("Failed to load offers.");
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublications();
    fetchOffers();
  }, []);

  return (
    <PublicationContext.Provider value={{ rows, fetchPublications, news, offers, fetchOffers }}>
      <style>
        {`
          .custom-tooltip {
  position: relative; /* Important for stacking */
  cursor: pointer;
  z-index: 1000; /* tooltip trigger element ko bhi upar lao */
}

.custom-tooltip::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: white;
  color: black;
  padding: 8px 12px;
  font-size: 12px;
  border-radius: 20px;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  z-index: 9999; /* tooltip ko sabse upar lao */
}

.custom-tooltip:hover::before {
  visibility: visible;
  opacity: 1;
}
        `}
      </style>
      {children}
    </PublicationContext.Provider>
  );
};

PublicationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePublications = () => useContext(PublicationContext);
